<template>
    <span class="projectContent">
        <h1 class="projectTitle">
            World of Gravity
        </h1>
        <h2 class="projectSubTitle">
         Created to explore the effect of Gravity
        </h2>
        <p>
            This is a game made with the Unity game engine to explore the amazing force in our world-Gravity.
        </p>
        <p>
            When players click on the screen, a ball of random size, which represents an object with different mass, will be generated. The created object will then react to the gravity field generated by the rest of the objects in the scene.
        </p>
        <p>
            As you can see from the video below, the objects'
            amazing trajectories reveal the nature of our universe.
        </p>
        <br>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/KMF9nGV43CU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </span>
  
</template>

<script>
export default {
    name:"Gravity Game"

}
</script>

<style>


</style>